import type { CSSProperties } from 'react';

import './styles.scss';

type Dimension = number | string;
type BoneTag = 'span' | 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'p' | 'small';

const NBSP = '\u00A0';

const toCss = (value?: Dimension) => (typeof value === 'number' ? `${value}px` : value);

interface PlaceholderProps {
  as?: BoneTag;
  w?: Dimension;
  h?: Dimension;
  radius?: Dimension;
  className?: string;
  style?: CSSProperties;
}

/**
 * A loading bone.
 *
 * Omit `h` and the bone carries a non-breaking space instead: its height then comes from whatever
 * line-height `as` + `className` resolve to, so a bone standing in for an `h1` keeps tracking that
 * `h1` through every breakpoint override without restating a pixel value here.
 */
export default function Placeholder({ as: Tag = 'span', w, h, radius, className = '', style }: PlaceholderProps) {
  return (
    <Tag
      aria-hidden="true"
      className={['skeleton-bone', className].filter(Boolean).join(' ')}
      style={{ width: toCss(w), height: toCss(h), borderRadius: toCss(radius), ...style }}
    >
      {h === undefined ? NBSP : null}
    </Tag>
  );
}
